import React from 'react';
import { graphql } from 'gatsby';
import Box from '../../components/Box/Box';
import { Headline } from '../../components/Typography/Typography';
import WithSection from '../../components/WithSection/WithSection';
import Image from '../../components/Image/Image';
import Slider from 'react-infinite-logo-slider';
import useViewport from '../../hooks/useViewport';

const LogosSection = ({ data: { primary, items } }) => {
    const { subheading } = primary;
    const { isMobile } = useViewport();

    return (
        <Box
            display="flex"
            flexDirection="column"
            gridColumn={{ _: '1/-1', lg: '2/-2' }}
        >
            <Headline fontSize="18px" marginBottom="33px" textAlign="center">
                {subheading}
            </Headline>
            {
                <Slider
                    width={isMobile ? '170px' : '225px'}
                    duration={30}
                    pauseOnHover={true}
                    blurBorders
                    blurBoderColor={'#fff'}
                    gap="40px"
                >
                    {items.map(({ image }, i) => (
                        <Slider.Slide css={{ justifyContent: 'center' }}>
                            <Image img={image} />
                        </Slider.Slide>
                    ))}
                </Slider>
            }
            {/*<Box*/}
            {/*    width="100%"*/}
            {/*    height="48px"*/}
            {/*    alignSelf="center"*/}
            {/*    display={{ md: 'none' }}*/}
            {/*>*/}
            {/*    <Carousel*/}
            {/*        centerMode={false}*/}
            {/*        mode="presentation"*/}
            {/*        slidesToShow={2}*/}
            {/*        slidesToScroll={2}*/}
            {/*        autoplay*/}
            {/*        dots*/}
            {/*        appendDots={(dots) => (*/}
            {/*            <Box top="60px">*/}
            {/*                <Carousel.Dots>{dots}</Carousel.Dots>*/}
            {/*            </Box>*/}
            {/*        )}*/}
            {/*    >*/}
            {/*        {items.map(({ image }, i) => (*/}
            {/*            <Box key={i} marginX="10px" paddingX="10px">*/}
            {/*                <Image*/}
            {/*                    img={image}*/}
            {/*                    style={{*/}
            {/*                        height: '100%',*/}
            {/*                        width: `${*/}
            {/*                            parseInt('30') **/}
            {/*                            (image.dimensions.width /*/}
            {/*                                image.dimensions.height)*/}
            {/*                        }px`,*/}
            {/*                    }}*/}
            {/*                />*/}
            {/*            </Box>*/}
            {/*        ))}*/}
            {/*    </Carousel>*/}
            {/*</Box>*/}
        </Box>
    );
};

// TODO: convert to fragments
export const _ = graphql`
    fragment LOGOS_SECTION on PrismicLogosSectionDefault {
        primary {
            subheading
            images_min_height
        }
        items {
            image {
                gatsbyImageData(layout: CONSTRAINED, height: 36)
                url
                alt
                dimensions {
                    width
                    height
                }
            }
        }
    }
`;

export default WithSection(LogosSection);
